import React from 'react';
import { Phone, CheckCircle } from 'lucide-react';
import { companyInfo } from '../data/mock';
import VideoSurveyDemo from './VideoSurveyDemo';

const QuoteForm = () => {
  return (
    <section id="quote-form" className="relative overflow-hidden">
      <div className="bg-[#0f1729] py-24 lg:py-28">
        {/* Ambient gradient blurs */}
        <div className="absolute top-1/4 left-0 w-96 h-96 bg-[#3B43AF]/20 rounded-full blur-3xl pointer-events-none"></div>
        <div className="absolute bottom-1/4 right-0 w-80 h-80 bg-emerald-500/10 rounded-full blur-3xl pointer-events-none"></div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* ===== Header ===== */}
          <div className="text-center max-w-3xl mx-auto mb-12 lg:mb-16">
            <span className="inline-block px-4 py-1.5 bg-emerald-500/15 text-emerald-400 font-semibold text-sm rounded-full mb-6 tracking-wide font-mono uppercase">
              Live Demo
            </span>

            <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold leading-tight mb-6">
              <span className="text-white">Record your inventory. </span>
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 via-orange-400 to-rose-400">
                We'll send an accurate quote.
              </span>
            </h2>

            <p className="text-lg text-gray-400 leading-relaxed">
              Watch a real walkthrough — our AI identifies furniture, art, and bulky items in seconds.
              No phone calls, no guesswork, just an accurate fixed-price quote.
            </p>
          </div>

          {/* ===== Demo ===== */}
          <VideoSurveyDemo />

          {/* ===== Benefits + CTA ===== */}
          <div className="mt-12 lg:mt-16 max-w-3xl mx-auto">
            <div className="grid sm:grid-cols-2 gap-3 mb-8">
              {[
                'Takes less than 2 minutes',
                'AI-powered instant pricing',
                'Fixed-price quote — no surprises',
                'Fully insured, professional service'
              ].map((benefit) => (
                <div key={benefit} className="flex items-center gap-3">
                  <CheckCircle className="w-5 h-5 text-emerald-400 flex-shrink-0" />
                  <span className="text-gray-300 text-sm">{benefit}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href={`tel:${companyInfo.phone.replace(/\s/g, '')}`}
                className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-[#3B43AF] hover:bg-[#4850C9] text-white font-semibold text-lg rounded-full transition-all duration-300 hover:shadow-lg hover:shadow-[#3B43AF]/30 group"
                data-testid="quote-call-btn"
              >
                <Phone className="w-5 h-5" />
                Call us for a quote
              </a>

              <div className="text-gray-500 text-sm">
                or ring us on <a
                  href={`tel:${companyInfo.phone.replace(/\s/g, '')}`}
                  className="text-white font-semibold hover:text-[#7C83E0] transition-colors"
                >
                  {companyInfo.phone}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuoteForm;
